import { isAxiosError } from 'axios';

export function getTimerActionError(error: unknown): string {
  if (isAxiosError<{ message?: unknown }>(error)) {
    const message = error.response?.data?.message;
    if (message === 'Cannot start tournament with no entrants counted') {
      return '無法開賽：參賽人數為 0，請先按「人數 +」增加至至少 1 人。';
    }
    if (typeof message === 'string' && message.trim()) return message;
  }
  return '操作失敗，請確認網路連線後再試。';
}
